import React from 'react'
import { Container } from 'react-bootstrap'
import BlueOne from './img/Group 325.png';
import BlueTwo from './img/Group 326.png';
import BlueThree from './img/Group 327.png';
import BlueFour from './img/Group 328.png';

function MiddleSection_ab(){
    
    const middleBigWrap = {
        backgroundColor: 'rgba(47,121,217, 0.2 )',
        height: 'auto'
      }
      
    const textUp = {
        fontSize: '30px',
        marginBottom: 40
    }
      
    const imgSize = {
        height: '32px'
    }

    const lineHeight = {
        lineHeight: '1.8em',
        fontSize: '15px'
    }
    const marginBottom = {
        marginBottom: 50
    }
    const marginBottom2 = {
        marginBottom: 71
    }
    const paddings = {
        padding: '50px 0'
    }
    return (
        
            <div style={middleBigWrap}>
                <Container style={paddings}>
                    <div style={textUp} className="font-weight-bold">ABYS의 주요 서비스</div>
                    <div className="row">
                        <div className="col-6 row">
                            <div className="col-12 row p-0" style={marginBottom}>
                                <div className="col-1 pl-3 pl-md-0">
                                    <img src={BlueOne} style={imgSize}/>
                                </div>
                                <div className="col">
                                    <span className="font-weight-bold" style={lineHeight}>ABYS 토탈멀티서비스는 자동차와 건물의 크리닝과 윈도우필름을 통한 에너지 세이빙, 외관의 유지관리를 컨설팅 및 서비스 진행, 사후관리를 진행하는 토탈 관리 서비스입니다.</span>
                                </div>
                            </div>
                            <div className="col-12 row p-0">
                                <div className="col-1 pl-3 pl-md-0">
                                    <img src={BlueThree} style={imgSize}/>
                                </div>
                                <div className="col">
                                    <span className="font-weight-bold" style={lineHeight}>우리나라 환경에 맞춘 서비스 SOP(Standard Operation Precedure - 표준작업절차)를 개발하여 전국 동일 서비스품질을 공급합니다.</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 row">
                            <div className="col-12 row p-0" style={marginBottom2}>
                                <div className="col-1 pl-3 pl-md-0">
                                    <img src={BlueTwo} style={imgSize}/>
                                </div>
                                <div className="col">
                                    <span className="font-weight-bold" style={lineHeight}>ABYS 서비스는 ICT (Information & Communication Technology) 기술을 도입한 서비스 관리 프로그램 입니다.</span>
                                </div>
                            </div>
                            <div className="col-12 row p-0">
                                <div className="col-1 pl-3 pl-md-0">
                                    <img src={BlueFour} style={imgSize}/>
                                </div>
                                <div className="col">
                                    <span className="font-weight-bold" style={lineHeight}>ABYS 서비스는 서비스에 사용되는 재료의 브랜드가 상이하므로 A/S가 발생 시 시공하신 대리점에서만 서비스가 가능합니다.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </Container>
            </div>
        
        
    )
}

export default MiddleSection_ab